import React from 'react';
import { makeStyles } from "@mui/styles";
import { Grid, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { actions } from '../../Config/constants';

//icons
import { IoIosSearch } from "react-icons/io";
import { MdChecklist } from "react-icons/md";

export default function ActionStep(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <Box className={classes.orderContainer} sx={{ border: '1px solid darkgrey', borderRadius: '8px' }}>
        <Box sx={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column' }}>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px', paddingBottom: '10px', background: '#ededed', borderTopLeftRadius: '8px', borderTopRightRadius: '8px', borderBottom: '1px solid darkgrey' }}>{t('Actions')}</Box>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs sx={{ display: 'flex', justifyContent: 'center', borderRight: '1px solid darkgrey', flexDirection: 'column', alignItems: 'center', paddingTop: '15px', paddingBottom: '15px' }}>
                    <Button variant="contained" className={[classes.okButton, classes.desktop]} startIcon={<IoIosSearch />} onClick={() => props.openActionDialog(actions.SEARCH_SSCC)} >{t('Search by SSCC')}</Button>
                    <Button variant="contained" className={[classes.okButton, classes.mobile]} startIcon={<IoIosSearch />} onClick={() => props.openActionDialog(actions.SEARCH_SSCC)} >{t('SSCC')}</Button>
                </Grid>
                <Grid item xs sx={{ display: 'flex', justifyContent: 'center', borderRight: '1px solid darkgrey', flexDirection: 'column', alignItems: 'center', paddingTop: '15px', paddingBottom: '15px' }}>
                    <Button variant="contained" className={[classes.okButton, classes.desktop]} startIcon={<MdChecklist />} onClick={() => props.openActionDialog(actions.ACTIVE_SSCC)} >{t('Search open orders')}</Button>
                    <Button variant="contained" className={[classes.okButton, classes.mobile]} startIcon={<MdChecklist />} onClick={() => props.openActionDialog(actions.ACTIVE_SSCC)} >{t('Order')}</Button>
                </Grid>
                <Grid item xs sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', paddingTop: '15px', paddingBottom: '15px' }}>
                    <Button variant="contained" className={[classes.okButton, classes.desktop]} startIcon={<IoIosSearch />} onClick={() => props.openActionDialog(actions.SEARCH_PRODUCT)}>{t('Search by product')}</Button>
                    <Button variant="contained" className={[classes.okButton, classes.mobile]} startIcon={<IoIosSearch />} onClick={() => props.openActionDialog(actions.SEARCH_PRODUCT)}>{t('Product')}</Button>
                </Grid>
            </Grid>
        </Box>
    </Box>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        width: "100%"

    },
    okButton: {
        color: "white !important",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main + ' !important',
        '&:hover': {
            backgroundColor: "white !important",
            color: FlagstoneTheme.palette.primary.main + ' !important',
            border: "1px solid " + FlagstoneTheme.palette.primary.main,
        },
        border: "1px solid " + FlagstoneTheme.palette.primary.main + ' !important',
    },

    desktop: {
        display: 'inline-flex !important',
        '@media (max-width: 900px)': {
            display: 'none !important'
        }
    },

    mobile: {
        display: 'none !important',
        '@media (max-width: 900px)': {
            display: 'inline-flex !important'
        }
    }

});